import { DateTime } from "luxon";

const DEFAULT_FORMAT = "MMM dd, yyyy 'at' h:mm a";

interface CalendarFormats {
  today?: string;
  yesterday?: string;
  previousWeek?: string;
  previousMonth?: string;
  previousYear?: string;
}

export const formatCalendar = (
  dateStr: string,
  formats?: CalendarFormats
): string => {
  const date = DateTime.fromISO(dateStr);
  if (!date.isValid) return "";

  const now = DateTime.local();

  if (date.hasSame(now, "day"))
    return date.toFormat(formats?.today || "'Today at' h:mm a");
  if (date.hasSame(now.minus({ days: 1 }), "day"))
    return date.toFormat(formats?.yesterday || "'Yesterday at' h:mm a");
  if (date.hasSame(now.minus({ weeks: 1 }), "week"))
    return date.toFormat(formats?.previousWeek || DEFAULT_FORMAT);
  if (date.hasSame(now.minus({ months: 1 }), "month"))
    return date.toFormat(formats?.previousMonth || DEFAULT_FORMAT);
  if (date.hasSame(now.minus({ years: 1 }), "year"))
    return date.toFormat(formats?.previousYear || DEFAULT_FORMAT);

  return date.toFormat(DEFAULT_FORMAT);
};

// Renders the span a digest covers, e.g. "2:00 PM – 2:30 PM". Both ISO strings carry an offset, so
// Luxon converts them to the viewer's local timezone before formatting. When the span crosses a day
// boundary the end keeps a short date so it stays unambiguous.
export const formatTimeRange = (startStr: string, endStr: string): string => {
  const start = DateTime.fromISO(startStr);
  const end = DateTime.fromISO(endStr);
  if (!start.isValid || !end.isValid) return "";

  const startLabel = start.toFormat("h:mm a");
  const endLabel = start.hasSame(end, "day")
    ? end.toFormat("h:mm a")
    : end.toFormat("MMM dd, h:mm a");
  return `${startLabel} – ${endLabel}`;
};
